var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isOverlayActive),expression:"isOverlayActive"}],staticClass:"black-overlay",style:({
      'z-index': _vm.zIndex,
    }),on:{"click":_vm.handleClickOverlay}})])
}
var staticRenderFns = []

export { render, staticRenderFns }